import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../lib/api';
import type { IngestSourceUploadResult } from '../lib/types';

export function useUploadIngestSource() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (vars: { file: File; runNow: boolean }) => {
      const form = new FormData();
      form.append('file', vars.file);
      return apiClient.postForm<IngestSourceUploadResult>(
        `/api/admin/ingest/upload-source?runNow=${vars.runNow}`,
        form,
      );
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['ingest-runs'] });
    },
  });
}
